<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
<gm-showcase>
  <div class="showcase-body">
    <div class="margin: auto; max-width: 1000px; margin-bottom: 50px;margin-top: 20px;">
      <span class="section-header">Add New</span>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sml-4 col-xs-4 group">
          <input id="newCourseNum" #newCourseNum class="modelo-text-input" type="text" (blur)="onBlur($event)" maxlength="30">
          <label for="newCourseNum">Course Number:</label>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-8 col-xs-8 group">
          <input id="newCourseName" #newCourseName class="modelo-text-input" type="text" (blur)="onBlur($event)" maxlength="70">
          <label for="newCourseName">Course Name:</label>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-4 group">
          <button id="addNewCouse" class="btn-xs btn-primary btn-group"
                  (click)="addNew(newCourseNum.value, newCourseName.value)"><i
            class="fa fa-save"></i>&nbsp;Submit
          </button>
        </div>
      </div>
      <div>&nbsp;</div>
      <table class="bordered-table highlight-table">
        <thead>
        <tr>
          <th>Course Number</th>
          <th>Course Name</th>
          <th>Active
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let train of training; let i = index">
          <td>
            <input class="modelo-text-input" type="text" [(ngModel)]="train.courseNumber"
                   (change)="updateIndexes(i)" maxlength="30">
          </td>
          <td>
            <input class="modelo-text-input" type="text" [(ngModel)]="train.courseName" (change)="updateIndexes(i)" maxlength="70">
          </td>
          <td>
            <select id="active" name="active" [(ngModel)]="train.active" (change)="updateIndexes(i)">
              <option [value]="true" [selected]="train.active == true">true</option>
              <option [value]="false" [selected]="train.active == false">false</option>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</gm-showcase>
<div style="z-index:1; position:absolute; margin-left: 80px; margin-top: 6px;">
  <button id="SaveChange" #SaveChange class="btn btn-primary-white btn-group" (click)="saveChanges()"><i class="fa fa-save"></i>&nbsp;Save</button>&nbsp;
  <button id="ResetChange" #ResetChange class="btn btn-primary-white btn-group" onclick="window.location.reload()">
    <i class="fa fa-refresh"></i>&nbsp;Reset</button>&nbsp;
  <span style="color: White; font-weight: bold;"> {{returnMessage}}</span>
</div>

